<template>
	<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="750">
		<v-card elevation="0" max-height="800">
			<v-card-title class="pl-4 pt-4">
				服务角色
				<v-spacer></v-spacer>
				<v-btn class="mx-0" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider class="grey lighten-2" />
			<v-card-text>
				<v-row class="pa-0">
					<v-col cols="12" md="4" class="px-0 pb-0">
						<v-card class="elevation-0">
							<v-card-title class="pl-0">
								<v-text-field v-model="appName" @blur="queryAppByName" @input="queryAppByName" placeholder="名称" append-icon="mdi-magnify" hide-details outlined dense clearable></v-text-field>
							</v-card-title>
							<v-divider></v-divider>
							<v-list class="pt-0 tree_scrollbar" flat style="min-height: 500px; max-height: 630px; overflow-x: hidden; overflow: hidden; overflow-y: scroll">
								<v-list-item-group v-if="apps.length > 0" v-model="appSelect" color="blue" active-class="app_nav">
									<div v-for="(item, i) in apps" :key="i">
										<v-list-item class="rounded pl-0 pr-1" @click="roleQuery(item)">
											<v-list-item-avatar color="blue-grey lighten-5" class="ml-0" size="30" style="border-radius: 8px">
												<v-icon color="primary" size="20">{{ item.props }}</v-icon>
											</v-list-item-avatar>
											<v-list-item-content>
												<v-list-item-title class="font-weight-regular">{{ item.name }}</v-list-item-title>
											</v-list-item-content>
											<v-list-item-action class="d-inline-block">
												<v-icon color="grey lighten-1" size="18">mdi-apple-keyboard-control mdi-rotate-90</v-icon>
											</v-list-item-action>
										</v-list-item>
										<v-divider inset></v-divider>
									</div>
								</v-list-item-group>
								<div v-else class="text-center">
									<v-img src="@/assets/img/urole_dsh.png" class="mx-auto mt-4" max-width="200"></v-img>
									<p class="body-1 grey--text">请申请相应服务资质后操作</p>
								</div>
							</v-list>
						</v-card>
					</v-col>
					<v-col cols="12" md="8" class="px-0 pb-0">
						<v-card class="elevation-0">
							<v-card-title class="pb-5 pt-5">
								{{ aName }}角色
								<v-spacer />
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text v-if="rolesShow" class="pl-4">
								<v-row v-if="rolesData.length > 0">
									<v-col v-for="(dataItem, i) in rolesData" :key="i" md="6" class="pb-1 pr-0">
										<v-list-item @click="roleSave(dataItem)" class="rounded-lg px-3" :style="dataItem.roleHas == 1 ? 'border:1px #2196f3 solid' : 'border:1px #F44336 dashed'">
											<v-list-item-avatar :color="dataItem.roleHas == 1 ? 'primary' : 'error'" size="36" class="mr-3">
												<v-icon color=" white"> {{ dataItem.roleHas == 1 ? "mdi-account-multiple-check-outline" : "mdi-account-multiple-remove-outline" }} </v-icon>
											</v-list-item-avatar>
											<v-list-item-content class="py-2">
												<v-list-item-title class="body-2">{{ dataItem.name }}<span v-if="dataItem.rsgx == '1'" class="caption orange--text">（互斥）</span></v-list-item-title>
												<v-list-item-subtitle :title="dataItem.note" class="caption mt-1">{{ dataItem.note }}</v-list-item-subtitle>
											</v-list-item-content>
											<img v-if="dataItem.roleHas == '1'" src="@/assets/img/ysq.png" alt="" class="img_tab" />
										</v-list-item>
									</v-col>
								</v-row>
								<div v-else class="text-center">
									<v-img src="@/assets/img/urole_dsh.png" class="ma-auto" max-width="200"></v-img>
									<p class="body-1 grey--text">暂无角色信息</p>
								</div>
							</v-card-text>
							<v-card-text v-else class="text-center">
								<v-img src="@/assets/img/urole_dsh.png" class="ma-auto" max-width="200"></v-img>
								<p class="body-1 grey--text">请选择应用后查看业务角色</p>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import Request from "@/commons/request";
import Message from "../../components/message";
export default {
	data() {
		return {
			dialog: false,
			aName: "", //点击的应用的名称
			apps: [],
			appName: "",
			appsClone: [],
			rolesShow: false,
			rolesData: [],
			sobj: {},
			appSelect: null,
		};
	},
	mounted() {
		this.user = this.$vtk.storage.get("_wit_acis_users");
	},
	methods: {
		view(sobj) {
			this.appSelect = null;
			this.dialog = true;
			this.sobj = sobj;
			this.appsQuery();
		},
		// 1. App可管理列表
		appsQuery() {
			this.rolesShow = false;
			const params = { codex: { did: this.user.did } };
			Request.postJson("/rbac/role-duid/list", params).then((res) => (this.apps = this.appsClone = res.data));
		},
		//1.1. 应用检索
		queryAppByName() {
			this.apps = this.appName ? this.appsClone.filter((item) => item.name.indexOf(this.appName) >= 0) : this.appsClone;
		},
		// 2. 查询App对应的角色
		roleQuery(item) {
			this.rolesShow = true;
			this.aName = item.name;
			const params = { codex: { aid: item.aid, did: this.user.did, uid: this.sobj.id } };
			Request.postJson("/rbac/role-duid/mtop", params).then((res) => {
				this.rolesData = res.data || [];
			});
		},
		//角色保存
		roleSave(item) {
			Message.loading.show();
			let entity = { id: item.id };
			if (item.roleHas == "0") {
				entity = {
					typ: this.user.did,
					rid: item.rid,
					oid: this.sobj.id,
					remark: "业务权限:" + this.user.username + "-" + item.name,
					operator: this.user.username, //管理人员
				};
			}
			Request.postJson("/rbac/role-duid/save", entity).then((res) => {
				if (res.meta.success) {
					item.id = res.data.id;
					item.roleHas = item.roleHas == "1" ? "0" : "1";
					Message.toast("用户角色授权成功", { color: "success" });
				} else {
					Message.toast("用户角色授权失败", { color: "error" });
				}
				Message.loading.hide();
			});
		},
		close() {
			this.dialog = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.img_tab {
	width: 40px;
	height: 42px;
	position: absolute;
	right: -2px;
	top: -2px;
}
</style>
